export class Helper {

  convertToCapital(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
}


// WEBPACK FOOTER //
// ./src/app/utilities/helper.ts